/*
 *
 * Copyright 2022, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */
import './WrcReports.css';

import React from "react";
import PropTypes from "prop-types";

import { WrcAccrualReports } from './WrcAccrualReports';
import { WrcSpecimenReports } from './WrcSpecimenReports';
import { WrcVisitReports } from './WrcVisitReports';

import {Card, Elevation} from "@blueprintjs/core";
import {Tabs, Tab} from "@blueprintjs/core";
import {WrcServer} from "./WrcServer";

export class WrcReports extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            window_height: window.innerHeight + 'px',
            window_width: window.innerWidth + 'px',
            reports: [],
            report_data: {},
            current_tab: 'tab1',
            is_loaded: false
        };
        this.getSpecimenData = this.getSpecimenData.bind(this)
        this.getAccrualData = this.getAccrualData.bind(this)
        this.getVisitData = this.getVisitData.bind(this)
        this.handleTabChange = this.handleTabChange.bind(this)

        // check reports in props, run necessary ajax, set data in table by report
        let reports = this.props.reports.map((report) => {return report.report_component})
        if (reports.includes('WrcSpecimenReports')) {
            WrcServer.post('get-specimen-reports',
            this.props.reports.filter((report) => report.report_component === 'WrcSpecimenReports')[0],
            (resp) => {
                this.getSpecimenData(resp)
            });
        }
        if (reports.includes('WrcAccrualReports')) {
            WrcServer.post('get-accrual-reports',
            this.props.reports.filter((report) => report.report_component === 'WrcAccrualReports')[0],
            (resp) => {
                this.getAccrualData(resp)
            });
        }
        if (reports.includes('WrcVisitReports')) {
            WrcServer.post('get-visit-reports',
            this.props.reports.filter((report) => report.report_component === 'WrcVisitReports')[0],
            (resp) => {
                this.getVisitData(resp)
            });
        }
    }
    
    componentDidUpdate(prevProps, prevState) {
        // all report data is loaded... so load the component
        if (Object.keys(prevState.report_data).length !== Object.keys(this.state.report_data).length) {
            if (Object.keys(this.state.report_data).length === this.props.reports.length) {
                this.setState({
                    is_loaded: true
                })
            }
        }
    }

    getSpecimenData = (content) => {
        let current_data = this.state.report_data
        current_data['WrcSpecimenReports'] = content 
        this.setState({
            report_data: {}
        }, () => this.setState({
            report_data: current_data
        }))
    }

    getAccrualData = (content) => {
        let current_data = this.state.report_data
        current_data['WrcAccrualReports'] = content
        this.setState({
            report_data: {}
        }, () => this.setState({
            report_data: current_data
        }))
    }

    getVisitData = (content) => {
        let current_data = this.state.report_data
        current_data['WrcVisitReports'] = content 
        this.setState({
            report_data: {}
        }, () => this.setState({
            report_data: current_data
        }))
    }

    handleTabChange = (tabId) => {
        this.setState({
            current_tab: tabId
        });
    }

    displayReports() {
        let report_layout_class= this.props.report_layout === 'horizontal' ? 'rowC' : ''
        let report_tab = []
        let props = {}
        let report_tabs = this.props.parent_report_tabs.map((tab, index) => {
            report_tab = []
            this.props.reports.forEach((report) => {
                const filtered_report = Object.assign({}, {...report}, {report_tabs: undefined});
                props = {
                    ...report.report_tabs.filter((t) => t.title === tab)[0], 
                    ...filtered_report
                }
                props.cohort_short_names = this.props.cohort_short_names
                switch (report.report_component) {
                    case 'WrcAccrualReports':
                        props.data = this.state.report_data['WrcAccrualReports'].filter((t) => t.title === tab)
                        report_tab.push((<WrcAccrualReports {...props}/>))
                        break;
                    case 'WrcSpecimenReports':
                        props.data = this.state.report_data['WrcSpecimenReports'].filter((t) => t.title === tab)
                        report_tab.push((<WrcSpecimenReports {...props}/>))
                        break;
                    case 'WrcVisitReports':
                        props.data = this.state.report_data['WrcVisitReports'].filter((t) => t.title === tab)
                        report_tab.push((<WrcVisitReports {...props}/>))
                        break;
                }
            })
            return (
                <Tab title={tab} id={'tab'+(index+1)} panel={
                    <Card interactive={false} className='wd-card-m-top lowpad' style={{height: '100%', width: '100%'}}>       
                        <div className={report_layout_class}>
                            {report_tab}
                        </div>
                    </Card>
                }/>
            )
        })
       
        return (
            <div style={{minHeight:'580px'}} className={report_layout_class}>
                <Card interactive={false} elevation={Elevation.ONE} style={{height: '100%', width: '100%'}}>
                        <Tabs
                            large={false}
                            renderActiveTabPanelOnly={true}
                            onChange={this.handleTabChange}
                            selectedTabId={this.state.current_tab}>
                                {report_tabs}
                        </Tabs>
                </Card>
            </div>
        )
    }

    render() {
        return this.state.is_loaded ?
            (this.displayReports()) : (
            <div>
                <Card style={{height:'560px'}}><h3>Loading...</h3></Card>
            </div>
        )
    }
}

WrcReports.propTypes = {
    reports: PropTypes.array.isRequired
};
